export default {
    systemInfo: { version: 'N/A', startupTimedOut: false, countries: [] },
    site: {},
    user: {
        initialized: false,
        isAuthenticated: false,
        impersonation: false,
        id: -1,
        details: false,
        granttype: false,
        impersonatedCountry: null
    },
    logs: {
        numberOfPages: 1,
        page: 1,
        pageSize: 100,
        totalItemCount: 0,
        items: []
    },
    download: {
        isRunning: false,
        loaded: 0,
        total: 0,
        startTime: null,
        speed: 'not started',
        latestProgress: new Array(10),
        latestChunk: 0
    },
    imageEditors: [],
    language: {},
    templates: [],
    se360Users: [],
    productTypes: [],
    planFirms: [],
    productGroups: []
};
